module.exports = __webpack_public_path__ + "static/img/exhLogo.701bba17.png";